import * as React from 'react';
import { compareStrings } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';

const BASE_CLASS_NAME =
	'bodyregular inline-flex h-7 cursor-pointer items-center gap-1.5 rounded-full border border-solid px-3 transition-colors';

// The active pill is filled with the role's own colour, matching the theme's primary. Both variants
// are written out in full so Tailwind's scanner sees every class it has to generate.
const getStateClassNames = (userType: string) =>
	compareStrings(userType, ROLE_TYPES.SUPPLIER)
		? {
				active: 'border-supplier bg-supplier text-white',
				inactive:
					'border-grey-5 bg-white text-character-primary hover:border-supplier hover:text-supplier',
		  }
		: {
				active: 'border-buyer bg-buyer text-white',
				inactive:
					'border-grey-5 bg-white text-character-primary hover:border-buyer hover:text-buyer',
		  };

interface NotesMediaFilterPillProps {
	value: string;
	label: string;
	/** All has no icon; every other filter is labelled with the icon its rows carry. */
	icon?: React.ReactNode;
	isActive: boolean;
	userType: string;
	onSelect: (value: string) => void;
}

/** One rounded filter button in the Media, Files & Links filter row. */
const NotesMediaFilterPill: React.FC<NotesMediaFilterPillProps> = ({
	value,
	label,
	icon,
	isActive,
	userType,
	onSelect,
}) => {
	const stateClassNames = getStateClassNames(userType);
	const handleClick = () => onSelect(value);

	return (
		<button
			type="button"
			className={`${BASE_CLASS_NAME} ${
				isActive ? stateClassNames.active : stateClassNames.inactive
			}`}
			onClick={handleClick}
		>
			{icon}
			<span>{label}</span>
		</button>
	);
};

export default NotesMediaFilterPill;
